import React, { useContext } from "react";
import { gql, useQuery } from "@apollo/client";

import Spinner from "../../components/Spinner";
import JobSchedulesCalendar from "../../components/JobSchedules/JobSchedulesCalendar";
import StarekContext from "../../context/StarekContext";

const JobSchedules = (props) => {
    const starekContext = useContext(StarekContext);

    const GET_JOB_SCHEDULES = gql`
        query GetJobSchedules {
            jobSchedules {
                id
                name
                created_at
                description
                cycle {
                    created_at
                    description
                    id
                    is_active
                    name
                    plant_id
                    plant {
                        code
                        name
                    }
                }
                cycle_id
                part_id
                part {
                    id
                    name
                    plant_id
                    description
                    is_active
                }
                device_id
                end_time
                start_time
                plant_id
                plant {
                    name
                    id
                }
            }
        }
    `;

    const { data, loading, refetch } = useQuery(GET_JOB_SCHEDULES, {
        client: starekContext.engineClient,
    });

    const jobSchedules = data?.jobSchedules ?? [];

    return loading ? (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "100vh" }}
        >
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-calendar fa-10x text-success"></i>
            </div>
            <Spinner />
        </div>
    ) : (
        <JobSchedulesCalendar jobSchedules={jobSchedules} onRefresh={refetch} />
    );
};

export { JobSchedules };
